module.exports = __webpack_public_path__ + "img/ziarovka_third.583ebd0b.svg";